import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=2b943bfc"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports